<span id="remove-button" class="material-symbols-outlined red lg bold clickable" (click)="remove()">close</span>
